import type { ComponentProps } from "react"

export default function Floors(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "hsl(var(--foreground))", ...svgProps } = props

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M7.64043 5.63049L10.3804 7.19549C10.4574 7.2391 10.5214 7.30234 10.5659 7.37876C10.6104 7.45518 10.6339 7.54205 10.6339 7.63049C10.6339 7.71894 10.6104 7.8058 10.5659 7.88222C10.5214 7.95864 10.4574 8.02188 10.3804 8.06549L6.13043 10.5005C5.97841 10.5883 5.80596 10.6345 5.63043 10.6345C5.45489 10.6345 5.28245 10.5883 5.13043 10.5005L0.880427 8.06549C0.803478 8.02188 0.739474 7.95864 0.694945 7.88222C0.650415 7.8058 0.626953 7.71894 0.626953 7.63049C0.626953 7.54205 0.650415 7.45518 0.694945 7.37876C0.739474 7.30234 0.803478 7.2391 0.880427 7.19549L3.62043 5.63049M6.13043 6.50044C5.97841 6.58821 5.80596 6.63441 5.63043 6.63441C5.45489 6.63441 5.28245 6.58821 5.13043 6.50044L0.880427 4.06544C0.803478 4.02183 0.739474 3.95859 0.694945 3.88217C0.650415 3.80575 0.626953 3.71889 0.626953 3.63044C0.626953 3.54199 0.650415 3.45513 0.694945 3.37871C0.739474 3.30229 0.803478 3.23905 0.880427 3.19544L5.13043 0.760439C5.28245 0.672671 5.45489 0.626465 5.63043 0.626465C5.80596 0.626465 5.97841 0.672671 6.13043 0.760439L10.3804 3.19544C10.4574 3.23905 10.5214 3.30229 10.5659 3.37871C10.6104 3.45513 10.6339 3.54199 10.6339 3.63044C10.6339 3.71889 10.6104 3.80575 10.5659 3.88217C10.5214 3.95859 10.4574 4.02183 10.3804 4.06544L6.13043 6.50044Z"
        stroke={fill}
        strokeWidth="1.2525"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
